// 📁 frontend/src/pages/AdminLayout.js
import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';

function AdminLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const admin = JSON.parse(localStorage.getItem('admin'));
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  // ✅ نحدد إذا كانت صفحة للطباعة فقط
  const isPrintPage = location.pathname.includes("/admin/orders/print");

  const handleLogout = () => {
    localStorage.removeItem('admin');
    navigate('/admin/login');
  };

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const navItems = [
    { path: '/admin/dashboard', label: '📊 لوحة التحكم' },
    { path: '/admin/orders', label: '🧾 الطلبات' },
    { path: '/admin/products/create', label: '➕ إضافة منتج' },
    { path: '/admin/categories', label: '📁 الفئات' },
    { path: '/admin/zones', label: '🚚 مناطق التوصيل' },
    { path: '/admin/costs', label: '📉 التكاليف' }, // ✅ تمت الإضافة هنا
  ];

  return (
    <div style={styles.layout}>
      {/* ✅ لو صفحة طباعة → اعرض المحتوى فقط بدون Sidebar */}
      {isPrintPage ? (
        <main style={{ width: '100%', padding: '15px' }}>
          <Outlet />
        </main>
      ) : (
        <>
          {/* زر القائمة في الجوال */}
          {isMobile && (
            <button
              onClick={() => setMenuOpen(true)}
              style={styles.menuButton}
            >
              ☰
            </button>
          )}

          {/* خلفية شفافة عند فتح القائمة */}
          {isMobile && menuOpen && <div style={styles.overlay} onClick={() => setMenuOpen(false)} />}

          {/* الشريط الجانبي */}
          <aside
            style={{
              ...styles.sidebar,
              ...(isMobile
                ? { transform: menuOpen ? 'translateX(0)' : 'translateX(100%)' }
                : { transform: 'translateX(0)' }),
            }}
          >
            <div style={styles.sidebarHeader}>
              <span style={styles.adminIcon}>👤</span>
              <span style={styles.adminName}>{admin?.name || 'المشرف'}</span>
            </div>

            <nav style={styles.navList}>
              {navItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  style={{
                    ...styles.navLink,
                    ...(location.pathname === item.path ? styles.navLinkActive : {}),
                  }}
                  onClick={() => isMobile && setMenuOpen(false)}
                >
                  {item.label}
                </Link>
              ))}
            </nav>

            <button onClick={handleLogout} style={styles.logoutButton}>🚪 تسجيل الخروج</button>
          </aside>

          {/* المحتوى الرئيسي */}
          <main
            style={{
              ...styles.mainContent,
              ...(isMobile ? { marginRight: 0, paddingTop: '70px' } : {}),
            }}
          >
            <Outlet />
          </main>
        </>
      )}
    </div>
  );
}

/* 🎨 الستايل */
const styles = {
  layout: {
    display: 'flex',
    direction: 'rtl',
    fontFamily: "'Cairo', sans-serif",
    backgroundColor: '#f9f7f3',
    minHeight: '100vh',
  },
  menuButton: {
    position: 'fixed',
    top: '15px',
    left: '15px',
    zIndex: 1100,
    backgroundColor: '#3f3d56',
    color: '#fff',
    padding: '12px 14px',
    borderRadius: '50%',
    border: 'none',
    cursor: 'pointer',
    fontSize: '20px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.35)',
    zIndex: 1000,
  },
  sidebar: {
    position: 'fixed',
    top: 0,
    right: 0,
    width: '260px',
    height: '100vh',
    backgroundColor: '#fffaf2',
    borderLeft: '1px solid #e6dac5',
    boxShadow: '-2px 0px 15px rgba(0,0,0,0.07)',
    padding: '30px 20px',
    display: 'flex',
    flexDirection: 'column',
    zIndex: 1050,
    transition: 'transform 0.3s ease-in-out',
  },
  sidebarHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '30px',
    color: '#3f3d56',
  },
  adminIcon: {
    fontSize: '26px',
  },
  adminName: {
    fontSize: '18px',
    fontWeight: '600',
  },
  navList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    flexGrow: 1,
  },
  navLink: {
    padding: '12px 14px',
    textDecoration: 'none',
    color: '#3f3d56',
    fontSize: '16px',
    borderRadius: '8px',
    transition: 'all 0.25s ease',
    backgroundColor: '#fff',
    border: '1px solid #e6dac5',
  },
  navLinkActive: {
    backgroundColor: '#3f3d56',
    color: 'white',
    border: '1px solid transparent',
  },
  logoutButton: {
    backgroundColor: '#e74c3c',
    color: 'white',
    padding: '12px',
    borderRadius: '6px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '600',
  },
  mainContent: {
    flex: 1,
    padding: '25px',
    marginRight: '260px',
    transition: 'margin-right 0.3s',
  },
};

export default AdminLayout;
